/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RefreshingInputs */

const en_refreshing = /** @type {(inputs: RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refreshing…`)
};

const de_refreshing = /** @type {(inputs: RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird aktualisiert …`)
};

/**
* | output |
* | --- |
* | "Refreshing…" |
*
* @param {RefreshingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const refreshing = /** @type {((inputs?: RefreshingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RefreshingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_refreshing(inputs)
	return en_refreshing(inputs)
});